import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import baseUrl from "../../API/BaseUrl";


const initialState = {
  AddReview: [],
  AllReviews: [],
  DeleteReview: [],
  editReview: [],
  isLoading: true,
  isSuccess: true,
  errorMessage: "",
};


// to add new review
export const addNewReview = createAsyncThunk(
  "newReview/addNew",
  async ({ prodId, formData }) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      }
      const res = await baseUrl.post(`/api/v1/products/${prodId}/reviews`, formData, config);
      return res;
    } catch (error) {
      return error;
    }
  }
);

// to get all reviews
export const getAllReviews = createAsyncThunk(
  "getall/reviews",
  async ({ prodId, page, limit }) => {
    try {
      const res = await baseUrl.get(`/api/v1/products/${prodId}/reviews?page=${page}&limit=${limit}`);
      return res;
    } catch (error) {
      return error;
    }
  }
);


// to delete review
export const deleteReview = createAsyncThunk(
  "deleteOne/review",
  async (id) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      }
      const res = await baseUrl.delete(`/api/v1/reviews/${id}`,config);
      return res;
    } catch (error) {
      return error;
    }
  }
);

// to delete review
export const EditReview = createAsyncThunk(
  "EditOne/review",
  async ({id,data}) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      }
      const res = await baseUrl.put(`/api/v1/reviews/${id}`,data,config);
      return res;
    } catch (error) {
      return error;
    }
  }
);

const ReviewsSlice = createSlice({
  name: "Reviews",
  initialState,
  reducers: {},
  extraReducers: {
    [addNewReview.pending]: (state, action) => {
      state.isLoading = true
    },
    [addNewReview.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.AddReview = action.payload
    },
    [addNewReview.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload
    },
    [getAllReviews.pending]: (state, action) => {
      state.isLoading = true
    },
    [getAllReviews.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.AllReviews = action.payload
    },
    [getAllReviews.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload
    },
    [deleteReview.pending]: (state, action) => {
      state.isLoading = true
    },
    [deleteReview.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.DeleteReview = action.payload
    },
    [deleteReview.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload
    },
    [EditReview.pending]: (state, action) => {
      state.isLoading = true
    },
    [EditReview.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.editReview = action.payload
    },
    [EditReview.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload
    },
  },
});

export default ReviewsSlice.reducer;